export enum Brand {
  FLOW,
  BTC,
}

export enum Channel {
  whatsapp,
  assistance
}


export class LoggableProduct {
  brand: Brand = Brand.BTC;
  channel: Channel = Channel.whatsapp;
}

export class LogElement {
  cClass = '';
  level = '';
  type = '';
  product: LoggableProduct = new LoggableProduct();
  msisdn = '';
  message = '';
  content: any = {}
  timestamp = '';

  get interceptorLog() {
    return this.findKeyInContent('InterceptorLog')
  }

  findKeyInContent(str: string) {
    for (const [key,value] of Object.entries(this.content)) {
      if(key.startsWith(str)) {
        return value;
      }
    }
    return null;
  }
}

